import { isMobile } from 'react-device-detect';
import { openNewTab } from './Common';

function objectToGetParams(object) {
  const params = Object.entries(object)
    .filter(([, value]) => value !== undefined && value !== null)
    .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(String(value))}`);
  console.log('urlll', params);
  return params.length > 0 ? `?${params.join('&')}` : '';
}

export const socialMediaShare = (socialMediaName, url) => {
  if (socialMediaName == 'facebook') {
    const navUrl = 'https://www.facebook.com/sharer/sharer.php?u=' + url;
    openNewTab(navUrl, () => {
      window.location.href = navUrl;
    });
  } else if (socialMediaName == 'whatsapp') {
    const navUrl =
      (isMobile ? 'whatsapp://send' : 'https://web.whatsapp.com/send') +
      objectToGetParams({
        text: url
      });
    openNewTab(navUrl, () => {
      window.location.href = navUrl;
    });
  } else if (socialMediaName == 'linkedin') {
    const navUrl = `https://www.linkedin.com/shareArticle?mini=true&url=${url}`;
    openNewTab(navUrl, () => {
      window.location.href = navUrl;
    });
  }
};
